import * as React from "react";
import {Button, Popup} from "semantic-ui-react";
import {Icon} from "../../../../../../core/components/icon/icon";

interface AddButtonProps {
    active: boolean;
    onAdd?: (e: React.MouseEvent) => void;
}
export const AddButton = ({active, onAdd}: AddButtonProps) => (
    <>
        <Popup content="Gemeinden auswählen"
            trigger={
                <Button className={"add-parcel-selection"} circular size="mini"
                    active={active}
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onAdd) { onAdd(e); }
                    }}>
                    <Icon name={"navigate_plus"} />
                </Button>
            } />
    </>
);

interface UpdateButtonProps {
    active: boolean;
    onUpdate?: (e: React.MouseEvent) => void;
}
export const UpdateButton = ({active, onUpdate}: UpdateButtonProps) => (
    <>
        <Popup content="Perimeter auswählen und anpassen"
            trigger={
                <Button className={"update-parcel-selection"} circular size="mini"
                    active={active}
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onUpdate) { onUpdate(e); }
                    }}>
                    <Icon name={"map_location"} />
                </Button>
            } />
    </>
);
interface ClearButtonProps {
    onClear?: (e: React.MouseEvent) => void;
}
export const ClearButton = ({onClear}: ClearButtonProps) => (
    <>
        <Popup content="Auswahl aufheben"
            trigger={
                <Button className={"clear-parcel-selection"} circular size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onClear) { onClear(e); }
                    }}>
                    <Icon name={"selection_delete"} />
                </Button>
            } />
    </>
);

interface SaveButtonProps {
    onSave?: (e: React.MouseEvent) => void;
}
export const SaveButton = ({onSave}: SaveButtonProps) => (
    <>
        <Popup content="Speichern"
            trigger={
                <Button className={"save-parcel-selection"} primary size="mini"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        if (onSave) { onSave(e); }
                    }}>
                    <Icon name={"floppy_disk"} />
                       Speichern
                </Button>
            } />
    </>
);
